import axios from "axios";
import { detectPreferredLocale } from "../utils/locale";
const INSTALL_ID_KEY = "X-Install-ID";
function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    }
  );
}
function getOrCreateInstallId() {
  try {
    const existing = localStorage.getItem(INSTALL_ID_KEY);
    if (existing)
      return existing;
    const id = uuidv4();
    try {
      localStorage.setItem(INSTALL_ID_KEY, id);
    } catch (e) {
    }
    return id;
  } catch (e) {
    return uuidv4();
  }
}
function createApiInstance(config = {}) {
  const api = axios.create({
    baseURL: config.baseURL || "https://meerkats.app",
    timeout: 0,
    headers: {
      "Content-Type": "application/json"
    }
  });
  api.interceptors.request.use(
    (config2) => {
      if (config2.url && config2.url.includes("?")) {
        try {
          const [baseUrl, qs] = config2.url.split("?");
          const urlSearch = new URLSearchParams(qs || "");
          const fromUrl = {};
          for (const [k, v] of urlSearch.entries()) {
            if (v === "undefined" || v === "null")
              continue;
            fromUrl[k] = v;
          }
          config2.url = baseUrl;
          config2.params = Object.assign(
            {},
            fromUrl,
            config2.params || {}
          );
        } catch (e) {
        }
      }
      const cleanParams = (p) => {
        if (!p)
          return p;
        if (typeof URLSearchParams !== "undefined" && p instanceof URLSearchParams)
          return p;
        if (Array.isArray(p)) {
          return p.map(
            (v) => v && typeof v === "object" ? cleanParams(v) : v
          ).filter((v) => v !== void 0 && v !== null);
        }
        if (typeof p !== "object")
          return p;
        const out = {};
        Object.keys(p).forEach((k) => {
          const v = p[k];
          if (v === void 0 || v === null)
            return;
          if (typeof v === "object" && !(v instanceof Date)) {
            const nested = cleanParams(v);
            if (nested !== void 0 && nested !== null && (Array.isArray(nested) ? nested.length > 0 : Object.keys(nested).length > 0)) {
              out[k] = nested;
            }
          } else {
            out[k] = v;
          }
        });
        return out;
      };
      if (config2.params) {
        try {
          config2.params = cleanParams(config2.params);
        } catch (e) {
        }
      }
      if (!config2.headers)
        config2.headers = {};
      else if (config2.headers && config2.headers.common) {
        config2.headers = Object.assign(
          {},
          config2.headers.common,
          config2.headers
        );
        [
          "common",
          "get",
          "post",
          "put",
          "delete",
          "patch",
          "head",
          "options"
        ].forEach((k) => delete config2.headers[k]);
      }
      const installId = getOrCreateInstallId();
      if (!config2.headers[INSTALL_ID_KEY] && !config2.headers[INSTALL_ID_KEY.toLowerCase()]) {
        config2.headers[INSTALL_ID_KEY] = installId;
      }
      if (!config2.headers["X-Platform"]) {
        config2.headers["X-Platform"] = "web";
      }
      if (!config2.headers["X-Locale"]) {
        try {
          const stored = localStorage.getItem("locale");
          config2.headers["X-Locale"] = stored || detectPreferredLocale() || "ru";
        } catch (e) {
          config2.headers["X-Locale"] = detectPreferredLocale() || "ru";
        }
      }
      if (!config2.headers["X-Timezone"]) {
        try {
          config2.headers["X-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
          config2.headers["X-Timezone"] = "UTC";
        }
      }
      if (!config2.headers["X-Theme"]) {
        try {
          const stored = localStorage.getItem("theme");
          config2.headers["X-Theme"] = stored || "light";
        } catch (e) {
          config2.headers["X-Theme"] = "light";
        }
      }
      return config2;
    },
    (error) => Promise.reject(error)
  );
  return api;
}
let defaultInstance = createApiInstance();
function setDefaultInstance(instance) {
  defaultInstance = instance;
}
const axiosProxy = new Proxy(
  {},
  {
    get(target, prop) {
      return defaultInstance[prop];
    }
  }
);
var stdin_default = axiosProxy;
export {
  createApiInstance,
  stdin_default as default,
  setDefaultInstance
};
